import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { FormTitle, Text, SwitchField } from "ui-components/Form";

function VendorInfo({ formRender, control, errors, mode = "ADD" }) {
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Vendor Information" : "Vendor Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, editable, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(disabled && { disabled }),
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };
              let renderField;
              switch (data.type) {
                case "text":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "switch":
                  renderField = <SwitchField field={fieldProps} />;
                  break;
              }

              return (
                <Grid key={index} item xs={12}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default VendorInfo;
